// extracted by css-extract-rspack-plugin
export default {"icon":"icon-acdvBa"};